import React from 'react'

const Contact = () => {
    return (
        <div>
            <h4>Contact Us</h4>
        </div>
    )
}

export default Contact
